module.exports = __webpack_public_path__ + "img/cooperation_2.3fd83bd8.jpg";